import React from 'react';

import classNames from 'classnames';

interface FormHeaderProps {
  bigTitle: string;
  title?: string;
  text?: string | React.ReactNode;
  flex?: boolean;
  flexLeft?: React.ReactNode | string;
  flexRight?: React.ReactNode | string;
}

const FormHeader: React.FC<FormHeaderProps> = ({
  bigTitle,
  text,
  flex,
  flexRight,
  title,
}) => (
  <div
    className={classNames('login-form__header', {
      'login-form__header--flex': flex,
    })}
  >
    {flex ? (
      <>
        <div className="login-form_header-left">
          <h3 className="title-3 login-form__title-big">{bigTitle}</h3>
          {title && <h2 className="title-2 login-form__title">{title}</h2>}{' '}
        </div>
        <div className="login-form_header-right">{flexRight}</div>
      </>
    ) : (
      <>
        <h3 className="title-3 login-form__title-big">{bigTitle}</h3>
        {title && <h2 className="login-form__title">{title}</h2>}{' '}
        {text && <p className="login-form__text">{text}</p>}
      </>
    )}
  </div>
);

export default FormHeader;
